import { fetcher } from './apiClient';

export type OnlineDevice = {
    id: string;
    name: string;
    status: 'sport' | 'commercial' | 'idle';
    currentSport: string | null;
};

export type LiveKpis = {
    devicesOnline: number;
    showingSports: number;
    showingCommercials: number;
    idle: number;
    windowMinutes: number;
    onlineDevices: OnlineDevice[];
};

export type SportMixDeviceBreakdown = {
    id: string;
    name: string;
    count: number;
};

export type SportMixEntry = {
    sport: string;
    count: number;
    devices: SportMixDeviceBreakdown[];
};

export type ActivityHourBucket = {
    hour: string;
    sport: number;
    commercial: number;
    other: number;
};

export type StaleDevice = {
    id: string;
    name: string;
    lastPingAt: string | null;
};

export type PingSummary = {
    live: LiveKpis;
    sportMixToday: SportMixEntry[];
    activityLast24h: ActivityHourBucket[];
    staleDevices: StaleDevice[];
};

export const pingSummaryFetcher = (url: string): Promise<PingSummary> =>
    fetcher<PingSummary>(url);

export type DevicePingSummary = {
    sportMixToday: SportMixEntry[];
    activityLast24h: ActivityHourBucket[];
};

export const devicePingSummaryFetcher = (url: string): Promise<DevicePingSummary> =>
    fetcher<DevicePingSummary>(url);
